import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  ${tw`h-32 sm:h-64`}

  ${({ $size }) => $size === 'sm' && tw`h-16 sm:h-32`};
`
